// extracted by mini-css-extract-plugin
var _1 = "RentalPortalListingsBoardCardCover-moduleRentalPortalListingsBoardCardCover__JZEOg";
var _2 = "RentalPortalListingsBoardCardCover-moduleimage__wM0bI";
export { _1 as "RentalPortalListingsBoardCardCover", _2 as "image" }
